// Post Refs
export const POST = 'posts'
export const SET_LOADING_POST = 'SET_LOADING_POST';
export const UPLOAD_POST = 'UPLOAD_POST';
export const UPLOAD_POST_SUCCESS_MSG = 'Post created successfully.';
export const UPLOAD_POST_ERROR_MSG = 'Posts should not have the same title';
export const UPLOAD_POST_SUCCESS = 'UPLOAD_POST_SUCCESS';
export const UPLOAD_POST_RESET_MSGS = 'UPLOAD_POST_RESET_MSGS';
export const UPLOAD_POST_ERROR = 'UPLOAD_POST_ERROR';
export const GET_POSTS = 'GET_POSTS';
export const GET_CAT_POSTS = 'GET_CAT_POSTS';
export const GET_POST = 'GET_POST';
export const DELETE_POST_SUCCESS = 'DELETE_POST_SUCCESS';
export const DELETE_POST_RESET_MSGS = 'DELETE_POST_RESET_MSGS';
export const DELETE_POST_SUCCESS_MSG = 'Post deleted succesfully.'
export const EDIT_POST = 'EDIT_POST';
export const EDIT_POST_SUCCESS = 'EDIT_POST_SUCCESS';
export const EDIT_POST_SUCCESS_MSG = 'Post edited successfully.';
export const EDIT_POST_ERROR = 'EDIT_POST_ERROR';
export const EDIT_POST_ERROR_MSG = 'Post can not be edited, something went wrong!';
export const EDIT_POST_RESET_MSGS = 'EDIT_POST_RESET_MSGS';

// PostCat Refs
export const POSTCAT = 'postcategories'
export const SET_LOADING_POSTCAT = 'SET_LOADING_POSTCAT';
export const UPLOAD_POSTCAT = 'UPLOAD_POSTCAT';
export const EDIT_POSTCAT = 'EDIT_POSTCAT';
export const EDIT_POSTCAT_SUCCESS = 'EDIT_POSTCAT_SUCCESS';
export const EDIT_POSTCAT_SUCCESS_MSG = 'Post category edited successfully.';
export const EDIT_POSTCAT_ERROR = 'EDIT_POSTCAT_ERROR';
export const EDIT_POSTCAT_ERROR_MSG = 'Post category can not be edited, something went wrong!';
export const EDIT_POSTCAT_RESET_MSGS = 'EDIT_POSTCAT_RESET_MSGS';
export const UPLOAD_POSTCAT_SUCCESS_MSG = 'Post category created successfully.';
export const UPLOAD_POSTCAT_ERROR_MSG = 'Posts category should not have the same title';
export const UPLOAD_POSTCAT_SUCCESS = 'UPLOAD_POSTCAT_SUCCESS';
export const UPLOAD_POSTCAT_RESET_MSGS = 'UPLOAD_POSTCAT_RESET_MSGS';
export const UPLOAD_POSTCAT_ERROR = 'UPLOAD_POSTCAT_ERROR';
export const GET_POSTCATS = 'GET_POSTCATS';
export const GET_POSTCAT = 'GET_POSTCAT';


// post comment 
export const GET_COMMENTS = 'GET_COMMENTS'
export const REFRESH_COMMENTS = 'REFRESH_COMMENTS'

// Courses
export const UPLOAD_COURSE = 'UPLOAD_COURSE';
export const UPLOAD_COURSE_SUCCESS = 'UPLOAD_COURSE_SUCCESS';
export const UPLOAD_COURSE_ERROR = 'UPLOAD_COURSE_ERROR';
export const DELETE_COURSE = 'DELETE_COURSE';
export const DELETE_COURSE_SUCCESS = 'DELETE_COURSE_SUCCESS';
export const DELETE_COURSE_ERROR = 'DELETE_COURSE_ERROR';
export const DELETE_COURSE_SUCCESS_MSG = 'Course deleted succesfully.'
export const DELETE_COURSE_RESET_MSGS = 'DELETE_COURSE_RESET_MSGS';
export const UPLOAD_COURSE_VIDEO_SUCCESS = 'UPLOAD_COURSE_VIDEO_SUCCESS';
export const GET_FILTEREDCOURSES = 'GET_FILTEREDCOURSES';
export const GET_COURSES = 'GET_COURSES';
export const CLEAR_GET_COURSE = 'CLEAR_GET_COURSE';
export const GET_DRAFT_COURSES = 'GET_DRAFT_COURSES';
export const GET_COURSE = 'GET_COURSE';
export const GET_MYCOURSES = 'GET_MYCOURSES';
export const GET_SECTIONS = 'GET_SECTIONS';
export const GET_LECTURES = 'GET_LECTURES';
export const RESET_MSGS = 'RESET_MSGS';
export const UPLOAD_VIDEO_PROGRESS = 'UPLOAD_VIDEO_PROGRESS';
export const UPLOAD_COURSE_SECTION_VIDEO_SUCCESS = 'UPLOAD_COURSE_SECTION_VIDEO_SUCCESS';
export const UPLOAD_COURSE_SECTION_VIDEO_ERROR = 'UPLOAD_COURSE_SECTION_VIDEO_ERROR';

// Course Messages
export const UPLOAD_COURSE_SUCCESS_MSG = 'Course Information is successfully saved';
export const UPLOAD_COURSE_SECTION_SUCCESS_MSG = 'Course Section Information is successfully saved';

// Auth Messages
export const LOGIN_SUCCESS_MSG = 'You have logged in successfully.';
export const SIGNUP_SUCCESS_MSG = 'You have successfully registered and logged in.';
export const SIGNOUT_SUCCESS_MSG = 'You have logged out successfully.';
export const RESET_EMAIL_SUCCESS_MSG = 'Your account email has been reset successfuly.';
export const RESET_PASSWORD_SUCCESS_MSG = 'Your account password has been reset successfuly.';

// Auth
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_ERROR = 'LOGIN_ERROR';
export const SIGNOUT_SUCCESS = 'SIGNOUT_ERROR';
export const RESET_EMAIL_ERROR_MSG = 'RESET_EMAIL_ERROR_MSG';
export const RESET_PASSWORD_ERROR_MSG = 'RESET_PASSWORD_ERROR';
export const RESET_AUTH_MSG = 'RESET_AUTH_MSG';
export const SET_LOADING_AUTH = 'SET_LOADING_AUTH';
export const SET_USER = 'SET_USER';

export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_EMAIL_SUCCESS = 'RESET_EMAIL_SUCCESS';
export const RESET_EMAIL_ERROR = 'RESET_EMAIL_ERROR';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';

export const RESET_ERROR_MSG = 'RESET_ERROR_MSG';
export const RESET_SUCCESS_MSG = 'RESET_SUCCESS_MSG';
export const RESET_SIGNOUT_SUCCESS_MSG = 'RESET_SIGNOUT_SUCCESS_MSG';
export const REAUTH_ERROR_MSG = 'REAUTH_ERROR_MSG';

// Course Refs
export const COURSES = 'courses';
export const SET_LOADING = 'SET_LOADING';

//stripe payment
export const SAVE_TOKEN = 'SAVE_TOKEN';
export const SAVED_CARD_SUCCESS = 'SAVED_CARD_SUCCESS';
export const GET_PAYMENT_TOKEN = 'GET_PAYMENT_TOKEN';
export const IS_VALID_TOKEN = 'IS_VALID_TOKEN';
export const CLEAR_SAVED_CARD_MESSAGE = 'CLEAR_SAVED_CARD_MESSAGE'
//Users
export const GET_USERS = 'GET_USERS'
export const GET_USER = 'GET_USER'
export const GET_STUDENTS = 'GET_STUDENTS'
export const GET_USER_CARDS = 'GET_USER_CARDS'

export const REMOVED_USER_CARDS_SUCCESS = 'REMOVED_USER_CARDS_SUCCESS'
export const CLEAR_REMOVED_USER_CARDS_SUCCESS = 'CLEAR_REMOVED_USER_CARDS_SUCCESS'

export const DELETE_USER = 'DELETE_USER'
export const CLEAR_DELETE_USER = 'CLEAR_DELETE_USER'


// Users Refs
export const USERS = 'users';
export const CHANGE_PLAN = 'CHANGE_PLAN'
export const CLEAR_PLAN_MESSAGE = 'CLEAR_PLAN_MESSAGE'

// sign up flow 
export const SIGNUPFLOW_SUCCESS = 'SIGN_UP_FLOW'
export const SIGNUPFLOW_SUCCESS_MSG = 'Payment successfull'

// forgotpassword
export const FORGOTPASSWORD_USERCHECK_ERROR = 'FORGOTPASSWORD_USERCHECK_ERROR'
export const FORGOTPASSWORD_USERCHECK_ERROR_MSG = 'Email address not found'
export const GET_FORGOTPASSWORD_USER = 'GET_FORGOTPASSWORD_USER'

// playlist
export const UPDATE_PLAYLIST = 'UPDATE_PLAYLIST'

// media 
export const GET_MEDIA = 'GET_MEDIA';

// theme
export const THEME = 'theme'
export const GET_PP = 'GET_PP'
export const UPDATE_PP = 'UPDATE_PP'
export const UPDATE_PP_SUCCESS = 'UPDATE_PP_SUCCESS'
export const UPDATE_PP_SUCCESS_MSG = 'Privacy and Policy content updated successfully'
export const GET_TC = 'GET_TC'
export const UPDATE_TC = 'UPDATE_TC'
export const UPDATE_TC_SUCCESS = 'UPDATE_TC_SUCCESS'
export const UPDATE_TC_SUCCESS_MSG = 'Terms and Condition content updated successfully'

// email confirmation
export const EMAIL_TOKENS = 'emailtokens'
export const SET_LAST_VIEW_COURSE = 'SET_LAST_VIEW_COURSE'
export const CLEAR_LAST_VIEW_COURSE = 'CLEAR_LAST_VIEW_COURSE'

export const SHOWERROR_PAGE = 'SHOWERROR_PAGE'
export const SHOWERROR_PAGEBLOG = 'SHOWERROR_PAGEBLOG'